export class CustomContentPage {
  constructor(data) {
    this.data = data;
  }

  getContentBlock(key) {
    return this.data.content.custom_content_list.find(block => block.dev_id === key);
  }

  toJSON() {
    return this.data;
  }
}
